import { getLocale } from "../runtime";

const sv_shopin = /** @type {(inputs: {country: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Handla i ${inputs.country}`
};

const shopin = /** @type {(inputs: {country: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_shopin(inputs)
	return "shopIn";
};

export { shopin as "shopIn" };